import { z } from 'zod';

export const PromoTextDTO = z.object({
    originalPriceText: z.string(),
    legalMentionOne: z.string().optional(),
    legalMentionTwo: z.string().optional(),
});

export const PromoStandardTextDTO = PromoTextDTO;

export type PromoStandardTextDTO = z.infer<typeof PromoStandardTextDTO>;
